import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  margin16: {
    marginTop: 16,
    marginBottom: 16
  },
  margin32: {
    marginTop: 32
  }
}));

const Types = {
  NOT_FOUND: 'NOT_FOUND',
  FORBIDDEN: 'FORBIDDEN'
};

const getDefaultText = (t, type) => {
  return type === Types.FORBIDDEN ? t('error:forbbiden:accessDenied') : t('error:notFound:resourceNotFound');
};

const PageContentError = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { type } = props;
  const { text = getDefaultText(t, type) } = props;

  return (
    <Grid container align='center' justify='center' alignItems='center' className={classes.margin32}>
      <Grid item xs={11} sm={6} md={6} xl={6} >
        <Card variant='outlined' style={{ height: '150%' }} >
          <CardContent className={classes.margin16}>
            <Typography color='primary' variant='h6' component='div'> {text} </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

PageContentError.propTypes = {
  text: PropTypes.string,
  types: PropTypes.oneOf([Types.NOT_FOUND, Types.FORBIDDEN])
};

export { Types };

export default PageContentError;
